import { gql } from '@apollo/client';

export default gql`
  fragment ThreadListItem on Thread {
    _id
    title

    user {
      _id
      name
      email
      profilePicture
    }

    createdAt
    score
    views
    answersCount
  }
`;
